/**
 * @fileoverview `serverLockoutMs` — how long the SERVER's own throttle refused for.
 * @package @puffin-core/form-security
 *
 * Every API answers a throttled request `429 RATE_LIMIT_EXCEEDED` with `details.retryAfter` in seconds
 * (`@puffin-core/response-helpers` `sendRateLimitExceeded`), which `@puffin-core/api-client` normalizes to
 * `errorCode` + `errorDetails`. A form that runs `useRateLimit` hands this value to `lockFor`, so the one
 * client throttle — and the one countdown — speak for both sides.
 *
 * Moved here from login-shell's `utils/signInRefusal.js` (LIFE-SHORTLISTED-001 D13, 2026-10-13), so the web
 * logins and palm-native's sign-in read the server's lockout by ONE rule.
 *
 * @module @puffin-core/form-security/serverLockout
 */

/** The server's code for its own throttle's refusal (`@puffin-core/response-helpers` `ERROR_CODES`). */
export const SERVER_RATE_LIMIT_CODE = 'RATE_LIMIT_EXCEEDED';

/**
 * The server's lockout in milliseconds, when its refusal carries a usable one.
 *
 * @param {{errorCode?: ?string, errorDetails?: *}|null|undefined} err - an api-client normalized error
 * @returns {number|null} milliseconds, or null when the refusal is not the server's throttle or names no
 *   positive whole number of seconds
 */
export function serverLockoutMs(err) {
  if (err?.errorCode !== SERVER_RATE_LIMIT_CODE) return null;
  const seconds = err.errorDetails?.retryAfter;
  return Number.isInteger(seconds) && seconds > 0 ? seconds * 1000 : null;
}

export default serverLockoutMs;
